import React, { useEffect, useRef, useState } from 'react';
import { Download, FolderOpen } from 'lucide-react';
import { downloadInventory, loadInventoryDrive } from '../../services/inventoryApi';

export default function InventoryDownload({ inventoryId, inventory }) {
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');
  const [manifest, setManifest] = useState(null);
  const request = useRef(null);
  useEffect(() => () => request.current?.abort(), []);

  const perform = async (action) => {
    if (request.current) return;
    const controller = new AbortController();
    request.current = controller;
    setBusy(action);
    setError('');
    try {
      if (action === 'download') {
        await downloadInventory(inventoryId, controller.signal, inventory);
      } else {
        setManifest(await loadInventoryDrive(inventoryId, controller.signal, inventory));
      }
    } catch (err) {
      if (!controller.signal.aborted) {
        console.error('Error al consultar Excel de inventario:', err);
        setError(err.message);
      }
    } finally {
      if (!controller.signal.aborted) {
        request.current = null;
        setBusy('');
      }
    }
  };

  return (
    <div className="space-y-3 rounded-xl border border-violet-300/15 bg-black/10 p-4">
      <div className="flex flex-wrap gap-3">
        <button onClick={() => perform('download')} disabled={Boolean(busy)} className="inline-flex items-center gap-2 rounded-xl border border-violet-300/30 bg-violet-500/20 px-4 py-2.5 text-sm hover:bg-violet-500/30 disabled:opacity-50">
          <Download size={16} />{busy === 'download' ? 'Preparando descarga...' : 'Descargar Excel diario'}
        </button>
        <button onClick={() => perform('files')} disabled={Boolean(busy)} className="inline-flex items-center gap-2 rounded-xl border border-violet-300/20 px-4 py-2.5 text-sm hover:bg-violet-400/10 disabled:opacity-50">
          <FolderOpen size={16} />{busy === 'files' ? 'Buscando archivos...' : 'Consultar archivos en Drive'}
        </button>
      </div>
      <p className="text-xs leading-5 text-violet-200/70">Archivos existentes del mismo día, cuenta y regiones. Varias regiones se descargan en ZIP. Drive no permite confirmar que sean la misma ejecución de la captura GCS.</p>
      {error && <p role="alert" className="text-sm text-red-300">{error}</p>}
      {manifest && <div className="text-sm">
        <a href={manifest.folder_url} target="_blank" rel="noopener noreferrer" className="text-emerald-300 underline">Abrir carpeta en Drive (requiere permisos de Drive)</a>
        <ul className="mt-2 space-y-1 text-xs text-violet-100/80">{manifest.files.map(file => <li key={file.id} className="break-all">{file.name}</li>)}</ul>
      </div>}
    </div>
  );
}
